import PropTypes from "prop-types";

const RenderToggle = ({ children, isToRender }) =>
  isToRender ? children : null;

RenderToggle.propTypes = {
  isToRender: PropTypes.bool.isRequired,
  children: PropTypes.element.isRequired
};

export default RenderToggle;
